import React from "react";
import "./HouseingTransform.css";

const EventCleaningTransform = () => {
  return (
    <section className="workplace-cta-section">
      <div className="workplace-cta-container">
        <h2 className="workplace-cta-title">
          Make Your Event Spotless & Memorable
        </h2>

        <p className="workplace-cta-text">
          Get professional event cleaning support for seamless, hygienic, and
          impressive corporate events
        </p>

        <a
          href="https://wa.me/919899811123?text=Event%20Cleaning%20Services"
          target="_blank"
          rel="noopener noreferrer"
          className="workplace-cta-btn"
        >
          Book Event Cleaning →
        </a>
      </div>
    </section>
  );
};

export default EventCleaningTransform;
